module.exports = __webpack_public_path__ + "img/06_Linear_Schieben_VFP@2x.628b94e2.jpg";